// extracted by mini-css-extract-plugin
export default {"logoutBtn":"_1u6zh","logoutIcon":"_1vjcU"};